import type { StyleRule } from '@archipro-design/aria';
import { boxClassName } from '@archipro-design/aria';
import { readMoreClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import {
    buttonClassName,
    labelClassName,
    pxToRem,
    SubheaderClassName,
} from '@archipro-design/aria';

export const Grid: StyleRule = ({ theme }) => ({
    width: '100%',
    padding: pxArrayToRem([24, 18]),
    [theme.screen.laptop]: {
        padding: 0,
        marginBottom: 0,
        [`& > .${SubheaderClassName}`]: {
            letterSpacing: theme.siteVariables.letterSpacingNormal,
        },
    },
});

export const Spacer: StyleRule = () => ({});

export const Summary: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colorScheme.default!.foreground,
    ...theme.siteVariables.textStyles.Text.Roman55,
    '& > *:first-child': {
        marginTop: 0,
    },

    [`&.${readMoreClassName} > .${boxClassName} a`]: {
        color: theme.siteVariables.colorScheme.default!.foreground,
        textDecoration: 'underline',
    },
    [`&.${readMoreClassName} .${buttonClassName}`]: {
        padding: pxArrayToRem([19, 0, 0]),
        backgroundColor: 'transparent',
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(14),
            textUnderlineOffset: pxToRem(3),
            textDecorationThickness: '1px',
            lineHeight: '100%',
        },
    },
    [theme.screen.laptop]: {
        fontSize: pxToRem(20),
        [`&.${readMoreClassName} .${buttonClassName}`]: {
            padding: 0,
            [`& .${labelClassName}`]: {
                fontSize: pxToRem(20),
            },
        },
    },
});

export const Content: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        '& *': {
            fontSize: pxToRem(20),
            '& strong': {
                fontWeight: 400,
            },
            '& b': {
                fontWeight: 400,
            },
        },
        [`& a`]: {
            textDecoration: 'underline !important',
        },
    },
});
